/**
 * v3.reports — WAVE-12 RAS Reports module client.
 *
 * Backed by Functions/ReportsFunction.cs:
 *   GET  /v3/reports                        Catalog
 *   GET  /v3/reports/{code}                 Definition
 *   POST /v3/reports/{code}/run             Execute (params in body)
 *   GET  /v3/reports/runs/{runId}           Fetch run + payload
 */

import type {
  RequestOptions,
  ReportCatalogResponse,
  ReportDefinitionDto,
  ReportRunDto,
  ReportRunResponse,
  ReportPayload,
} from '@retail-ops/shared-types';
import type { ApiHttpClient } from '../http.js';

export interface ReportDefinitionResponse {
  success: boolean;
  report?: ReportDefinitionDto;
  error?: string;
}

export interface ReportGetRunResponse {
  success: boolean;
  run?: ReportRunDto;
  payload?: ReportPayload;
  error?: string;
}

export class ReportsApi {
  public constructor(private readonly http: ApiHttpClient) {}

  public catalog(opts?: RequestOptions): Promise<ReportCatalogResponse> {
    return this.http.get<ReportCatalogResponse>('/v3/reports', { ...opts });
  }

  public definition(code: string, opts?: RequestOptions): Promise<ReportDefinitionResponse> {
    return this.http.get<ReportDefinitionResponse>(
      `/v3/reports/${encodeURIComponent(code)}`,
      { ...opts },
    );
  }

  public run(
    code: string,
    params: Record<string, string | number | boolean | undefined> = {},
    opts?: RequestOptions,
  ): Promise<ReportRunResponse> {
    return this.http.post<ReportRunResponse>(
      `/v3/reports/${encodeURIComponent(code)}/run`,
      { ...opts, body: params },
    );
  }

  public getRun(runId: string, opts?: RequestOptions): Promise<ReportGetRunResponse> {
    return this.http.get<ReportGetRunResponse>(
      `/v3/reports/runs/${encodeURIComponent(runId)}`,
      { ...opts },
    );
  }
}
